
// Libraries
import { Loader } from "@googlemaps/js-api-loader";
import { Component, Prop, Vue, Watch } from "nuxt-property-decorator";

import LoadingSpinner from "~/components/molecules/display/LoadingSpinner.vue";

@Component({
  components: {
    LoadingSpinner,
  },
})
export default class DynamicMapMolecule extends Vue {
  @Prop() addressData: {
    street: string;
    streetNumber: string;
    postalCode: string;
    city: string;
  };
  showMap = false;

  loader;
  map = null;
  waitingForAddressData = true;
  readyToRender = false;

  googleMapsApi = {
    apiKey: process.env.GMAPS_API_KEY,
  };

  mounted() {
    if (this.addressData) this.updateLoadingStatus(false);
  }

  @Watch("showMap")
  onShowMapChange() {
    this.initMap();
  }

  @Watch("addressData")
  onReceivingAddressData() {
    this.updateLoadingStatus(false);
  }

  initGoogleMapsLoader() {
    this.loader = new Loader({
      apiKey: this.googleMapsApi.apiKey,
      version: "weekly",
      region: "DE",
      libraries: ["places"],
    });
  }

  setReadyToRender(status: boolean) {
    this.readyToRender = status;
  }

  updateLoadingStatus(status: boolean) {
    this.waitingForAddressData = status;
  }

  initMap() {
    this.initGoogleMapsLoader();
    this.loader.loadCallback((e) => {
      if (!e) {
        const getCords = new Promise((resolve, reject) => {
          //@ts-ignore
          new google.maps.Geocoder().geocode(
            {
              address: `${this.addressData.street} ${this.addressData.streetNumber} ${this.addressData.postalCode} ${this.addressData.city}`,
            },
            function (results, status) {
              if (status === "OK") {
                resolve({
                  lat: results[0].geometry.location.lat(),
                  lng: results[0].geometry.location.lng(),
                });
              }
            },
          );
        });
        getCords.then((res: { lat: number; lng: number }) => {
          //@ts-ignore
          this.map = new google.maps.Map(this.$refs.googleMap, {
            center: {
              lat: res.lat,
              lng: res.lng,
            },
            zoom: 12,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false,
            zoomControl: false,
          });

          //@ts-ignore
          new google.maps.Marker({
            position: {
              lat: res.lat,
              lng: res.lng,
            },
            map: this.map,
          });

          this.setReadyToRender(true);
        });
      }
    });
  }
}
